export default __webpack_public_path__ + "static/media/transition4.3474af6f.mp3";